import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import LatestAnnouncementList from "@/Components/common/client/header/announcements/LatestAnnouncementList";
import ViewMoreOneAnnouncementModal from "@/Components/modals/client/announcementModal/ViewMoreOneAnnouncementModal";
import {
  fetchClientAllAnnouncementListData,
  setClientAllAnnouncementListLoading,
  updatePagination,
} from "@/reducers/clientAnnouncement";
import { updateactivePages } from "@/reducers/clientcommon";

import useTitle from "../../../utilities/hooks/useTitle";

const LatestAnnouncement = () => {
  useTitle("Announcement");
  const { pagination } = useSelector((state) => state.clientAnnouncement);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setClientAllAnnouncementListLoading(true));
    dispatch(fetchClientAllAnnouncementListData());
    dispatch(
      updateactivePages({
        activePage: "announcement",
        activeSubPage: null,
      }),
    );
  }, []);
  return (
    <div className="flex flex-col gap-4">
      <LatestAnnouncementList />
      <ViewMoreOneAnnouncementModal />
    </div>
  );
};

export default LatestAnnouncement;
